/** Shared tuning for Matrix binary surfaces (Phase 2+). */
export const BINARY_DEFAULTS = {
  cellsPerMeter: 12,
  glyphAspect: 0.72,
  flipSpeed: 3.2,
  scrollSpeed: 2.4,
  flickerSpeed: 4.5,
  flickerStrength: 0.18,
  pulseSpeed: 0.9,
  glowStrength: 1.48,
  atlasPixelSize: 64,
  buildingScrollSpeed: 3.1,
  buildingGlowStrength: 1.55,
};
